"use client";

import { c as _c } from "react/compiler-runtime";
import { useDebounceFn } from "ahooks";
import SearchInput from "app/components/SearchInput";
import { parseAsString, useQueryState } from "nuqs";
import { useEffect, useState } from "react";
type SearchBarProps = {
  variant?: "dark" | "light";
  className?: string;
};
export const useBlogQuery = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withDefault("");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQueryState("query", t0);
};
export const useBlogCategory = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withOptions({
      scroll: false
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQueryState("category", t0);
};
export const useBlogShowAll = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withDefault("");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQueryState("showAll", t0);
};
export function SearchBar(t0) {
  const $ = _c(17);
  const {
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "dark" : t1;
  const [query, setQuery] = useBlogQuery();
  const [, setCategory] = useBlogCategory();
  const [, setShowAll] = useBlogShowAll();
  let t2;
  if ($[0] !== query) {
    t2 = () => query ?? "";
    $[0] = query;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [inputValue, setInputValue] = useState(t2);
  let t3;
  if ($[2] !== setCategory || $[3] !== setQuery || $[4] !== setShowAll) {
    t3 = value => {
      setQuery(value || null);
      if (value) {
        setCategory(null);
        setShowAll(null);
      }
    };
    $[2] = setCategory;
    $[3] = setQuery;
    $[4] = setShowAll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      wait: 500
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    run: debouncedSetQuery
  } = useDebounceFn(t3, t4);
  let t5;
  let t6;
  if ($[7] !== query) {
    t5 = () => {
      if (!query) {
        setInputValue("");
      }
    };
    t6 = [query];
    $[7] = query;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== debouncedSetQuery) {
    t7 = value_0 => {
      setInputValue(value_0);
      debouncedSetQuery(value_0);
    };
    $[10] = debouncedSetQuery;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== className || $[13] !== inputValue || $[14] !== t7 || $[15] !== variant) {
    t8 = <SearchInput variant={variant} className={className} value={inputValue} onChange={t7} />;
    $[12] = className;
    $[13] = inputValue;
    $[14] = t7;
    $[15] = variant;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}